import type { paths } from '@pba/types-openapi-client';
import type { ConfigRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type GroupUsersPathRequestParams = paths['/v3/groups/{id}/users']['get']['parameters']['path'];
type GroupUsersQueryRequestParams = paths['/v3/groups/{id}/users']['get']['parameters']['query'];
type ResponseType = paths['/v3/groups/{id}/users']['get']['responses']['200']['content']['application/json'];

export const getGroupUsers = async ({
  config: { params },
  routeParams: { id },
}: ConfigRouteParamsRequest<GroupUsersQueryRequestParams, GroupUsersPathRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.groups.users(id), { params });
